import { render, staticRenderFns } from "./push-money-gather.vue?vue&type=template&id=228c129d&scoped=true&"
import script from "./push-money-gather.vue?vue&type=script&lang=ts&"
export * from "./push-money-gather.vue?vue&type=script&lang=ts&"
import style0 from "./push-money-gather.vue?vue&type=style&index=0&id=228c129d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228c129d",
  null
  
)

export default component.exports